<template>
    <div v-if='isVisible'>
        <div class="order-detail-container row no-wrap justify-center items-center">
    <!-- Эта херня показывается пока грузятся файлы -->
            <q-spinner-facebook color="negative" :size="30" v-if="fileLoading" />
    <!-- Показываем загруженные файлы -->
            <div v-if='!fileLoading' style="width:100%; padding:10px;" class="row justify-content-start">
                <!-- заголовок таблицы -->
                <div class="uppercase row no-wrap items-center full-width q-pa-sm bg-green-6 text-white text-weight-medium q-body-2">
                    <div class="col-2 ellipsis">Размер</div>
                    <div class="col-1 ellipsis">preview</div>
                    <div class="col-2 text-center ellipsis">Материал</div>
                    <div class="col-2 text-center ellipsis">Обработка</div>
                    <div class="col-2 text-center ellipsis">Количество</div>
                    <div class="col-3 ellipsis">Комментарии</div>
                </div>        
                <div v-for="item in files" :key='item.id' class="fileDetailLine row no-wrap items-center q-body-1" style="width:100%;">
                    <div class="file_size col-2 ellipsis">{{fileWidth(item)}} x {{fileHeight(item)}} м</div>
                    <div class="file_size col-1 ellipsis" v-on:mouseover='showPreview(filePreview(item))' v-on:mouseout='hidePreview()'><img :src='filePreview(item)' class='cursor-pointer' height=20 ></div>
                    <div class="materialName col-2 text-left ellipsis-3-lines q-pa-xs">{{materialName(item)}}</div>
                    <div class="col-2 text-center">{{getPost(item).types}}</div>
                    <div class="number col-2 text-center">{{fileNumber(item)}} шт</div>
                    <div class="comment col-3 ellipsis-3-lines">{{fileComment(item)}}</div>
                </div>
            </div>
        </div>
        <!-- превью -->
        <div v-if='previewVisible' class='fixed-center bg-white q-pa-sm z-max shadow-20'>
            <img :src='previewFileName'>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    name : 'orderLineDetails',

    props : {
        orderId : {
            type : Number,
            required : true            
        },
        isVisible : {
            // type : boolean,
            required : true
        }
    },
    data () {
        return {
            // isVisible : false,
            fileLoading : false,
            previewFileName : '',
            previewVisible : false,
            id : 0,
        }   
    },

    created() {
       this.id = this.orderId;
    //    eventBus.$on('showOrderDetails', this.showDetails);
    },

    beforeDestroy(){
       eventBus.$off('showOrderDetails');
       //console.log('строка сдохла '+ this.orderId);
    },
    watch: {
        isVisible : function(val) {
            if (val) { // если флаг true - загружаем данные
                this.fileLoading = true; // ставим флаг отображать статус загрузки
                this.$store.dispatch('getDetailsFiles', this.orderId)
                .then(()=>{
                    this.fileLoading =  false;
                })
                .catch((error)=>{
                    console.log(error);
                });
            }
        }
    },

    methods : {

        getPost(order) {
             let opt = order.options != null ? JSON.parse(order.options) : {};
             let p = opt.post != null ? opt.post : {"top":[],"right":[],"bottom":[],"left":[],"space":[]};
             let postResult = [];
             for (let key in p) {
                let value = p[key]; // получаем сторону обработки
                value.forEach(element => { //циклим по всем элементам обработки в стороне и проверяем есть ли такая в итоговой выборке
                    if (!postResult.includes(element)) postResult.push(element);
                });
             }
             // на этом этапе сформирована выборка. Теперь нужно сформировать условные обозначения
            let resultSt = '';
            postResult.forEach(element => {
                let s = this.$store.getters.getPostTypeById(element);
                if (s != null) {
                    if (resultSt != '') resultSt +='-';
                    resultSt += s.shortName;
                }
            });
            let r = postResult.length == 0 ? 'нет' : 'есть';
            return {isPost : r, types : resultSt > '' ? resultSt : '-'}
        },

        filePreview(item) {
            if ((item != undefined)&&(item.options != undefined)) {
                let opt = JSON.parse(item.options);
                return opt.preview_1 != undefined ? opt.preview_1 : '';
            }
        },


        fileComment(item) {
            if ((item != undefined)&&(item.options != undefined)) {
                let opt = JSON.parse(item.options);
                return opt.comment != undefined ? opt.comment : '';
            }
        },

        fileNumber(item) {
            if ((item != undefined)&&(item.options != undefined)) {
                let opt = JSON.parse(item.options);
                return opt.number != undefined ? opt.number : '';
            }
        },

        fileWidth(item) {
            if ((item != undefined)&&(item.options != undefined)) {
                let opt = JSON.parse(item.options);
                return opt.width != undefined ? opt.width : 'нет';
            }
            return 0;
        },
        fileHeight(item) {
            if ((item != undefined)&&(item.options != undefined)) {
                let opt = JSON.parse(item.options);
                return opt.height != undefined ? opt.height : 'нет';
            }
        },

        showPreview(filename) {
            if (!this.previewVisible) {
                this.previewFileName = filename;
                this.previewVisible = true;
            }
        },

        hidePreview() {
            this.previewVisible = false;
        },

        showDetails(orderId) {
            console.log('Show details ' + this.id);
            if (orderId != this.orderId) {
                this.isVisible = false; // скрываем область - т.к. не наш ордер
                return; // не наш ордер
            }
            
            this.isVisible = !this.isVisible; // переключаем флаг видимости
            
            if (this.isVisible) {

                this.fileLoading = true; // ставим флаг отображать статус загрузки
                this.$store.dispatch('getDetailsFiles', this.orderId)
                .then(()=>{
                    this.fileLoading =  false;
                })
                .catch((error)=>{
                    console.log(error);
                });
            }
        },

        materialName(item) {
            if ((item != undefined)&&(item.options != undefined)) {
                let opt = JSON.parse(item.options);
                let matId = opt.material != undefined ? opt.material : -1;
                var q = this.$store.getters.getMaterialById(matId);

                return (q != undefined) ? q.name : 'не задан';

            }
        }

    },
    computed : {

        files() {
            return this.$store.getters.getDetailsFiles(this.orderId);
        },

    }

}
</script>

<style lang="scss" scoped>

    .order-detail-container {
        background: white;
        border : 1px dotted gray;
        border-top : 0px;
        min-height:60px;
    }
    .fileDetailLine {
        min-height: 35px;
        padding: 8px;
        margin:2px;
        cursor: default;
        border : 1px dotted rgb(190, 190, 190);
        &:hover{
            background: rgb(184, 255, 184);
        }
    }

</style>
